<mat-form-field 
  [formGroup]="group"
  [ngClass]="loading ? 'nsc-form-field-loading' : ''">
  <mat-select
    role="listbox"
    [id]="idx"
    [formControlName]="controlName"
    [placeholder]="placeholder"
    [attr.aria-expanded]="selectedValue.opened"
    (openedChange)="openedChange($event)"
    (selectionChange)="changeValue($event)"
    [(value)]="selectedValue.id">
    <mat-option [attr.aria-selected]="obj.value === selectedValue.id ? true :false"
                *ngFor="let obj of selectObjects; let i = index"
                id = "{{idx}}_{{i}}"
                [value]="obj.value"
                [attr.aria-label]="obj.name" >
      {{ obj.name }}
    </mat-option>
  </mat-select>
   <mat-hint>{{ hint }}  
    <span [attr.aria-label]="required ? 'required': ''"  ></span>
  <span  aria-live="assertive" [attr.aria-label]="selectedValue.name"></span> 
  </mat-hint>
  <mat-error *ngIf="group.controls[controlName].invalid" [attr.aria-label]="hint + validationMessage.get(group.controls[controlName], placeholder) ">{{ hint }} {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
</mat-form-field>